'use client';

import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { type TransitionEvent, useEffect, useState } from 'react';
import { getAppleDeviceInfo } from '@shared/utils/helpers/get-apple-device-info';
import { DockIcon } from './icons/DockIcon';
import { HomeScreenIcon } from './icons/HomeScreenIcon';
import { ShareIcon } from './icons/ShareIcon';
import styles from './apple-prompt.module.scss';
type ApplePromptProps = {
  addHomeInstructionsLabelIos: string;
  addHomeInstructionsLabelSafari: string;
  bodyLabelIos: string;
  bodyLabelSafari: string;
  cancelLabel: string;
  onClose: () => void;
  shareInstructionsLabelIos: string;
  shareInstructionsLabelSafari: string;
  titleLabelIos: string;
  titleLabelSafari: string;
};
export const ApplePrompt = t0 => {
  const $ = _c(47);
  const {
    addHomeInstructionsLabelIos,
    addHomeInstructionsLabelSafari,
    bodyLabelIos,
    bodyLabelSafari,
    cancelLabel,
    onClose,
    shareInstructionsLabelIos,
    shareInstructionsLabelSafari,
    titleLabelIos,
    titleLabelSafari
  } = t0;
  const [isVisible, setIsVisible] = useState(false);
  const {
    isIosThirteenAndUp,
    isIPhone,
    isSafariSeventeenAndUp
  } = getAppleDeviceInfo();
  const visibilityClass = isVisible ? styles["is-visible"] : styles["is-hidden"];
  const isModernStyle = isIosThirteenAndUp || isSafariSeventeenAndUp;
  const modernStyle = isModernStyle && styles["is-modern"];
  const safariStyle = isSafariSeventeenAndUp && styles["is-safari"];
  const AddHomeIcon = isIPhone ? HomeScreenIcon : DockIcon;
  const addHomeInstructionsLabel = isIPhone ? addHomeInstructionsLabelIos : addHomeInstructionsLabelSafari;
  const bodyLabel = isIPhone ? bodyLabelIos : bodyLabelSafari;
  const shareInstructionsLabel = isIPhone ? shareInstructionsLabelIos : shareInstructionsLabelSafari;
  const titleLabel = isIPhone ? titleLabelIos : titleLabelSafari;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsVisible(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] !== isVisible) {
    t3 = () => {
      if (isVisible) {
        document.body.classList.add("no-scroll");
      }
    };
    t4 = [isVisible];
    $[2] = isVisible;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== onClose) {
    t5 = () => {
      document.body.classList.remove("no-scroll");
      setIsVisible(false);
      onClose();
    };
    $[5] = onClose;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleCancel = t5;
  let t6;
  if ($[7] !== isVisible) {
    t6 = event => {
      if (!isVisible) {
        event.currentTarget.style.display = "none";
      }
    };
    $[7] = isVisible;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const onTransitionOut = t6;
  const t7 = classnames(styles.prompt, visibilityClass, modernStyle, safariStyle);
  let t8;
  if ($[9] !== titleLabel) {
    t8 = <p className={styles.title}>{titleLabel}</p>;
    $[9] = titleLabel;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== cancelLabel || $[12] !== handleCancel) {
    t9 = <button className={styles["cancel-btn"]} onClick={handleCancel}>{cancelLabel}</button>;
    $[11] = cancelLabel;
    $[12] = handleCancel;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <div className={styles.header}>{t8}{t9}</div>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== bodyLabel) {
    t11 = <div className={styles.body}><div className={styles.description}><p className={styles.paragraph}>{bodyLabel}</p></div></div>;
    $[17] = bodyLabel;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isModernStyle) {
    t12 = <ShareIcon className={styles["share-icon"]} modern={isModernStyle} />;
    $[19] = isModernStyle;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = classnames(styles.paragraph, styles["paragraph--bold"]);
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== shareInstructionsLabel) {
    t14 = <p className={t13}>{shareInstructionsLabel}</p>;
    $[22] = shareInstructionsLabel;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t12 || $[25] !== t14) {
    t15 = <div className={styles["instruction-step"]}>{t12}{t14}</div>;
    $[24] = t12;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== AddHomeIcon || $[28] !== isModernStyle) {
    t16 = <AddHomeIcon className={styles["home-icon"]} modern={isModernStyle} />;
    $[27] = AddHomeIcon;
    $[28] = isModernStyle;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = classnames(styles.paragraph, styles["paragraph--bold"]);
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== addHomeInstructionsLabel) {
    t18 = <p className={t17}>{addHomeInstructionsLabel}</p>;
    $[31] = addHomeInstructionsLabel;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t16 || $[34] !== t18) {
    t19 = <div className={styles["instruction-step"]}>{t16}{t18}</div>;
    $[33] = t16;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t15 || $[37] !== t19) {
    t20 = <div className={styles.instructions}>{t15}{t19}</div>;
    $[36] = t15;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== bodyLabel || $[40] !== onTransitionOut || $[41] !== t10 || $[42] !== t11 || $[43] !== t20 || $[44] !== t7 || $[45] !== titleLabel) {
    t21 = <div aria-describedby={bodyLabel} aria-labelledby={titleLabel} className={t7} onTransitionEnd={onTransitionOut} role="dialog">{t10}{t11}{t20}</div>;
    $[39] = bodyLabel;
    $[40] = onTransitionOut;
    $[41] = t10;
    $[42] = t11;
    $[43] = t20;
    $[44] = t7;
    $[45] = titleLabel;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  return <><div aria-label={cancelLabel} className={classnames(styles.overlay, visibilityClass, modernStyle)} onClick={handleCancel} onTransitionEnd={onTransitionOut} role="button" />{t21}</>;
};